__turbopack_context__.v({
  "buttonContainer": "header-module-scss-module__NpYOBW__buttonContainer",
  "headerContainer": "header-module-scss-module__NpYOBW__headerContainer",
  "headerRow": "header-module-scss-module__NpYOBW__headerRow",
  "menuButton": "header-module-scss-module__NpYOBW__menuButton",
  "menuDropdown": "header-module-scss-module__NpYOBW__menuDropdown",
  "menuDropdownContainer": "header-module-scss-module__NpYOBW__menuDropdownContainer",
  "menuItem": "header-module-scss-module__NpYOBW__menuItem",
  "menuItem__button": "header-module-scss-module__NpYOBW__menuItem__button",
  "runQueryBtn": "header-module-scss-module__NpYOBW__runQueryBtn",
  "siteLogoImage": "header-module-scss-module__NpYOBW__siteLogoImage",
  "siteLogoText": "header-module-scss-module__NpYOBW__siteLogoText",
});
